import { FormattedNumber } from 'react-intl';
import { ReactElement } from 'react';

/**
 * An amount in a table: the figure on its own.
 *
 * The currency belongs in the column heading ("Netto €") and not in every
 * cell. Fifty rows of digits are read by comparing them against each other,
 * and a symbol repeated down the column only costs the figures room — the
 * amounts run to 14 characters as it is (LST-S17, GF 12.10.2026).
 *
 * The exception is a figure that is not in the currency of the column: it
 * carries its code, so it can never be read as euros.
 */

/** The sign a column heading carries for a currency. */
const SIGNS: Record<string, string> = {
    EUR: '€',
    CHF: 'CHF',
    GBP: '£',
    USD: '$',
};

export const paloCurrencySign = (currency?: string): string => (currency ? SIGNS[currency] ?? currency : '');

export interface PaloAmountProps {
    value: number;
    /** The currency of this one figure, where the rows can differ. */
    currency?: string;
    /** The currency of the column — the one its heading names. */
    base?: string;
    /** Four for a unit price, two for everything else (LST-S1). */
    maximumFractionDigits?: number;
}

export const PaloAmount = ({ value, currency, base, maximumFractionDigits = 2 }: PaloAmountProps): ReactElement => (
    <>
        <FormattedNumber value={value} minimumFractionDigits={2} maximumFractionDigits={maximumFractionDigits} />
        {currency && base && currency !== base ? ` ${currency}` : ''}
    </>
);
